import React from 'react';
import PageContainer from '../components/PageContainer';
import { FiShoppingCart } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const products = [
  { id: 1, name: "Sunflower Vintage Tee", price: "$35.00", image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?q=80&w=800&auto=format&fit=crop", badge: "New" },
  { id: 2, name: "Blurring The Edges Vinyl", price: "$40.00", image: "https://images.unsplash.com/photo-1603048297172-c92544798d5e?q=80&w=800&auto=format&fit=crop", badge: "Limited" },
  { id: 3, name: "Tour Poster '97", price: "$25.00", image: "https://images.unsplash.com/photo-1583345241088-062e081fd2e2?q=80&w=800&auto=format&fit=crop", badge: null },
  { id: 4, name: "Classic Logo Hoodie", price: "$65.00", image: "https://images.unsplash.com/photo-1556821840-3a63f95609a7?q=80&w=800&auto=format&fit=crop", badge: null },
  { id: 5, name: "Bitch Enamel Pin", price: "$12.00", image: "https://images.unsplash.com/photo-1611652022419-a9419f74343d?q=80&w=800&auto=format&fit=crop", badge: "Club Only" },
  { id: 6, name: "Signed Guitar Pick Set", price: "$20.00", image: "https://images.unsplash.com/photo-1550005740-0b6dc3d0e2e2?q=80&w=800&auto=format&fit=crop", badge: null },
];

export default function Store() {
  return (
    <PageContainer title="Official Store">
      <div className="flex justify-between items-center mb-8 border-b border-gray-800 pb-4">
        <p className="text-gray-400">Showing {products.length} items</p>
        <button className="flex items-center gap-2 bg-sun-yellow text-black px-4 py-2 rounded-full font-bold hover:bg-white transition-colors">
          <SafeIcon icon={FiShoppingCart} /> Cart (0)
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {products.map((product) => (
          <div key={product.id} className="bg-grunge-gray rounded-xl overflow-hidden group hover:shadow-[0_0_20px_rgba(255,215,0,0.15)] transition-all border border-transparent hover:border-sun-yellow/30">
            <div className="relative aspect-square bg-black overflow-hidden">
              {product.badge && (
                <div className="absolute top-4 right-4 bg-sun-yellow text-black text-xs font-bold uppercase py-1 px-3 rounded-full z-10">
                  {product.badge}
                </div>
              )}
              <img 
                src={product.image} 
                alt={product.name} 
                className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
              />
            </div>
            <div className="p-6">
              <h3 className="text-xl font-bold text-white mb-2">{product.name}</h3>
              <p className="text-sun-yellow text-lg font-display mb-4">{product.price}</p>
              <button className="w-full bg-transparent border-2 border-sun-yellow text-sun-yellow font-bold py-3 rounded hover:bg-sun-yellow hover:text-black transition-colors uppercase tracking-wider text-sm">
                Add to Cart
              </button>
            </div>
          </div>
        ))}
      </div>
    </PageContainer>
  );
}